import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Source from "./Source";
import Fetcher from "../Provider/Fetcher";
import PotreeBinParser from "../Parser/PotreeBinParser";
import PotreeCinParser from "../Parser/PotreeCinParser";

/**
 * @classdesc
 * PotreeSource are object containing informations on how to fetch points cloud resources.
 *
 *
 */
var PotreeSource = /*#__PURE__*/function (_Source) {
  _inherits(PotreeSource, _Source);
  var _super = _createSuper(PotreeSource);
  /**
   * @param {Object} source - An object that can contain all properties of a
   * PotreeSource
   * @param {string} source.url - folder url.
   * @param {string} source.file - cloud file name.
   *
   * This `cloud` file stores information about the potree cloud in JSON format. the structure is :
   *
   * * __`version`__ - The cloud.js format may change over time. The version number is
   * necessary so that parsers know how to interpret the data.
   * * __`octreeDir`__ - Directory or URL where node data is stored. Usually points to
   * "data".
   * * __`boundingBox`__ - Contains the minimum and maximum of the axis aligned bounding box. This bounding box is cubic and aligned to fit to the octree root.
   * * __`tightBoundingBox`__ - This bounding box thightly fits the point data.
   * * __`pointAttributes`__ - Declares the point data format. May be 'LAS', 'LAZ' or in case if the BINARY format an array of attributes like
   * `['POSITION_CARTESIAN', 'COLOR_PACKED', 'INTENSITY']`
   * * __`POSITION_CARTESIAN`__ - 3 x 32bit signed integers for x/y/z coordinates
   * * __`COLOR_PACKED`__ - 4 x unsigned byte for r,g,b,a colors.
   * * __`spacing`__ - The minimum distance between points at root level.
   * ```
   * {
   *     version: '1.6',
   *     octreeDir: 'data',
   *     boundingBox: {
   *         lx: -4.9854,
   *         ly: 1.0366,
   *         lz: -3.4494,
   *         ux: 0.702300000000001,
   *         uy: 6.7243,
   *         uz: 2.2383
   *     },
   *     tightBoundingBox: {
   *         lx: -4.9854,
   *         ly: 1.0375,
   *         lz: -3.4494,
   *         ux: -0.7889,
   *         uy: 6.7243,
   *         uz: 1.1245
   *     },
   *     pointAttributes: [
   *         'POSITION_CARTESIAN',
   *         'COLOR_PACKED'
   *     ],
   *     spacing: 0.03,
   *     scale: 0.001,
   *     hierarchyStepSize: 5
   * }
   * ```
   *
   * @extends Source
   *
   * @constructor
   */
  function PotreeSource(source) {
    var _this;
    _classCallCheck(this, PotreeSource);
    if (!source.file) {
      throw new Error('New PotreeSource: file is required');
    }
    _this = _super.call(this, source);
    _this.file = source.file;
    _this.fetcher = Fetcher.arrayBuffer;
    _this.extensionOctree = 'hrc';

    // For cloud specification visit:
    // https://github.com/PropellerAero/potree-propeller-private/blob/master/docs/file_format.md#cloudjs
    _this.whenReady = (source.cloud ? Promise.resolve(source.cloud) : Fetcher.json("".concat(_this.url, "/").concat(_this.file), _this.networkOptions)).then(function (cloud) {
      _this.pointAttributes = cloud.pointAttributes;
      _this.baseurl = "".concat(_this.url, "/").concat(cloud.octreeDir, "/r");
      _this.extension = cloud.pointAttributes === 'CIN' ? 'cin' : 'bin';
      _this.parse = _this.extension === 'cin' ? PotreeCinParser.parse : PotreeBinParser.parse;
      return cloud;
    });
    return _this;
  }
  return _createClass(PotreeSource);
}(Source);
export default PotreeSource;